import { render, staticRenderFns } from "./CoordinateFileDropzone.vue?vue&type=template&id=60aa598c"
import script from "./CoordinateFileDropzone.vue?vue&type=script&lang=js"
export * from "./CoordinateFileDropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports